import { useQuery } from "@apollo/client";
import { GET_PARTICIPANT_BY_ID } from "../gql";
import type { Participant } from "@casey/db-types";

interface ParticipantByIdResponse {
  participant: Pick<Participant, "id" | "externalId" | "organizationId"> | null;
}

interface ParticipantByIdVariables {
  participantId: string;
}

/**
 * Hook to fetch a participant by their ID (ext_* format).
 * Useful for checking if a session's participantUserId belongs to the current user
 * by comparing participant.externalId with the Clerk/guest user ID.
 */
export function useParticipantById(
  participantId: string | null | undefined,
  options: { skip?: boolean } = {},
) {
  const { data, loading, error, refetch } = useQuery<
    ParticipantByIdResponse,
    ParticipantByIdVariables
  >(GET_PARTICIPANT_BY_ID, {
    variables: {
      participantId: participantId || "",
    },
    skip: !participantId || options.skip,
    errorPolicy: "all",
  });

  return {
    participant: data?.participant || null,
    loading,
    error,
    refetch,
  };
}
